import Component from '../abstracts/Component';
import queryString from 'query-string';
import Observer from '../utils/ObserverIntersection';

export default class InfiniteScrollLogic extends Component {
  get SELECTORS() {
    return {
      main: '[data-infinite-scroll]',
      trigger: '[data-infinite-scroll-trigger]',
      label: '[data-infinite-scroll-label]'
    }
  }

  constructor() {
    super();
    this.viewMoreBtn = document.querySelector(this.SELECTORS.main);
    if(this.viewMoreBtn) {
      this.nextPage = document.querySelector(this.SELECTORS.main).dataset.page;
      this.label = this.viewMoreBtn.querySelector(this.SELECTORS.label);
    }
    const searchObj = queryString.parse(location.search);
    const preload = searchObj.preload;
    const page = parseInt(searchObj.page);
    this.wasPreloaded = preload || page > 0 || false;
    this.startPage = this.wasPreloaded ? page + 1 : 1;
    this.isBound = false;
  }

  // observer function
  observeScroll() {
    //console.log('observer scroll');
    this.internalObserveScroll();
  }

  // setting observer
  internalObserveScroll() {
    this.scrollObserver = new Observer(this.SELECTORS.trigger, 0, null, (entries, observer) => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          let nextPage = this.viewMoreBtn.dataset.page;
          let lastPage = this.viewMoreBtn.dataset.infiniteScrollLastpage;
          // if next page is minor than last
          if(parseFloat(nextPage) <= parseFloat(lastPage)) {
            this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.next, {page: nextPage});
          }
          observer.unobserve(entry.target);
        }
      });
    });
  }

  bindClickOnce() {
    this.isBound = true;
    
    // Handle keyboard activation
    const handleKeydown = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.stopPropagation();
        event.preventDefault();
        // hide it
        event.currentTarget.classList.add('--hidden');
        // start infinite scroll events with focus flag
        this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.next, {page: this.startPage, shouldFocus: true});
        this.isBound = false;
        event.currentTarget.removeEventListener('keydown', handleKeydown);
      }
    };
    
    // bind one click to trigger button
    this.$one('click.is', ({event}) => {
      event.stopPropagation();
      event.preventDefault();
      // hide it
      event.currentTarget.classList.add('--hidden');
      // start infinite scroll events without focus (mouse click)
      this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.next, {page: this.startPage, shouldFocus: false});
      this.isBound = false;
      document.querySelector(this.SELECTORS.main)?.removeEventListener('keydown', handleKeydown);
    }, this.SELECTORS.main);
    
    // Add keyboard listener
    document.querySelector(this.SELECTORS.main)?.addEventListener('keydown', handleKeydown);
  }

  bindEvents() {
    this.bindClickOnce();
  
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, ({ event, payload }) => {
      let lastPage = this.viewMoreBtn.dataset.infiniteScrollLastpage;
      let nextPage = this.viewMoreBtn.dataset.page;
  
      if (parseFloat(nextPage) < parseFloat(lastPage)) {
        this.observeScroll();
      }
    });
  
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({ event, payload }) => {
      let newButton = payload.response.querySelector(this.SELECTORS.main);
      if (newButton != null) {
        this.viewMoreBtn.classList.remove('--hidden');
        this.viewMoreBtn.dataset.page = this.nextPage;
        this.viewMoreBtn.dataset.infiniteScrollLastpage = newButton.getAttribute('data-infinite-scroll-lastpage');
        if (this.label) {
          this.label.innerHTML = newButton.querySelector(this.SELECTORS.label).innerHTML;
        }
      }
      if (!this.isBound) {
        this.bindClickOnce();
      }
    });
  }

  render() {
    this.log('Load logics...');
    // if i find the main i start the events
    if(this.viewMoreBtn) this.bindEvents();
  }
}
